import styled from 'styled-components'

import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    background-color: ${(props) => (props.mode === 'Dark' ? props.theme.color.p600 : props.theme.color.g100)};
`
